export const COOKIE_KEY_USER_ID = 'n_user_id';
export const COOKIE_KEY_SESSION_ID = 'n_cookid';
export const COOKIE_KEY_MAIL = 'n_email';
export const COOKIE_KEY_USER_NAME = 'n_username';
export const COOKIE_KEY_FIRST_LOGIN = 'firstLogin';
export const COOKIE_KEY_APP_LOAD_FROM = 'loadFrom';
export const COOKIE_KEY_APP_VIEW_DESKTOP = 'view_desktop';
export const COOKIE_KEY_COMPARED_MODELS = 'Newcar_carCode';
export const COOKIE_KEY_COMPARED_SUBMODELS = 'Newcar_Items';
export const COOKIE_KEY_NON_LOGIN_SHORTLIST = 'newcars';
